<script lang="ts" setup>
  import { watch } from "vue";
  import noise from "@/assets/images/noise.svg";
  import ModalHeaderIcon from "@/components/ModalHeaderIcon.vue";

  const props = defineProps<{
    modelValue: boolean;
    icon: string;
    title: string;
    subTitle: string;
    cta: Function;
  }>();

  const emit = defineEmits<{
    'update:modelValue': [value: boolean];
    'close': [];
  }>();

  function close() {
    emit('update:modelValue', false);
    emit('close');
  }
</script>

<template>
  <v-snackbar
    :model-value="props.modelValue"
    location="bottom left"
    :timeout="-1"
    @click="props.cta"
  >
    <div class="noise" :style="{ 'background-image': 'url(' + noise + ')' }"/>

    <ModalHeaderIcon class="icon" :icon="props.icon" :size="46" :iconSize="22"/>

    <div class="text">
      <div class="title">{{ props.title }}</div>
      <div class="sub-title">{{ props.subTitle }}</div>
    </div>

    <v-btn class="close-btn" size="40px" icon="close" color="primary-300" @click.stop="close"/>
  </v-snackbar>
</template>

<style lang="scss" scoped>
  :deep(.v-snackbar__wrapper) {
    border-radius: 1rem;

    left: 2rem !important;
    bottom: 1.5rem !important;
  }

  :deep(.v-snackbar__content) {
    position: relative;
    background-color: rgb(var(--v-theme-primary-300));
    width: 408px;
    height: 97px;
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.5rem 1.25rem;
    border: 3px solid rgb(var(--v-theme-neutral-100));
    border-radius: 1rem;
    cursor: pointer;

    .noise {
      position: absolute;
      left: 0;
      width: 100%;
      height: 100%;
      background-repeat: repeat;
      background-size: 1rem;
      z-index: 0;
      opacity: 0.175;
    }

    .icon {
      z-index: 1;
    }

    .text {
      z-index: 1;
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      color: white;
      line-height: 1.5rem;

      .title {
        font-weight: 700;
        font-size: 1.125rem;
      }

      .sub-title {
        font-weight: 400;
        font-size: 0.875rem;
      }
    }

    .close-btn {
      position: absolute;
      z-index: 10;
      top: -17px;
      right: -17px;
      border: 3px solid rgb(var(--v-theme-neutral-100));

    }

  }

  @media screen and (max-width: breakpoint(md) - 1px) {
    :deep(.v-snackbar__wrapper) {
      left: 0.5rem !important;
      bottom: 4rem !important;

      .v-snackbar__content {
        width: calc(100vw - 2rem);
      }
    }
  }
</style>
